import { gql } from '@apollo/client'
import { SOCIETY_FRAGMENT } from '@/graphql/fragments/society'
import { SocietyType } from '@/types/society'

export interface SocietyDataType {
  society: SocietyType
}

export interface SearchSocietyResult {
  name: string
  streetAddress: string
  city: string
  postalCode: string
  country: string
  countryCode: string
  siren: string
  legalStatusId: string
  legalStatusName: string
  leaderFirstname: string
  leaderLastname: string
}

export interface SearchSocietyDataType {
  searchSociety: SearchSocietyResult[]
}

export const GET_SOCIETY = gql`
  query getSociety {
    society {
      ...SocietyFragment
    }
  }
  ${SOCIETY_FRAGMENT}
`

export const SEARCH_SOCIETY = gql`
  query searchSociety($query: String!) {
    searchSociety(query: $query) {
      name
      streetAddress
      city
      postalCode
      country
      countryCode
      siren
      legalStatusId
      legalStatusName
      leaderFirstname
      leaderLastname
    }
  }
`
